import balanceText from 'balance-text';

// Import Swiper styles
import 'swiper/css/bundle';
import Af from './components/Af';
import AfMap from './components/AfMap';
import AnimateOnPageLinks from './components/AnimateOnPageLinks';
import ArchiveFilter from './components/ArchiveFilter';
import ContactModule from './components/ContactModule';
//import FadeInUpOnScroll from './components/FadeInUpOnScroll';
import Nav from './components/Nav';
import BearbetningSwiper from './components/swiper/bearbetningSwiper';
import caseSwiper from './components/swiper/caseSwiper';
import heroSwiper from './components/swiper/heroSwiper';
//import iconSwiper from './components/swiper/iconSwiper';
import popularSwiper from './components/swiper/popularSwiper';
import popularCat from './components/swiper/popularCatSwiper';
//import TillvalArchive from './components/TillvalArchive';
import RenoveringsForm from './components/RenoveringsForm';
import StickyHeader from './components/StickyHeader';
import MainNav from './components/MainNav';
import galleryBlock from './components/swiper/galleryBlock';
import initFaq from './components/Faq';
import { initToc, initMobileToc } from './components/Toc';
import videomodal from './components/video-modal';
import hoverLabelFix from './utils/hoverLabelFix';
import produktSlider from './components/swiper/ligtbox-slider';

heroSwiper.init();
popularSwiper.init();
galleryBlock.init();
caseSwiper.init();
popularCat.init();
//cdFadeInUpOnScroll.init();
jQuery(function ($) {
	produktSlider();
	videomodal.init();
	/* iconSwiper.init(); */
	ArchiveFilter.init();
	initFaq();
	initMobileToc();
	MainNav.init();
	Nav.init();
	ContactModule.init();
	//TillvalArchive.init();
	BearbetningSwiper.init();
	AnimateOnPageLinks.init();
	RenoveringsForm.init();
	AfMap.init();
	StickyHeader.init();
	initToc();
	Af.init();
	balanceText();
	/* 	jQuery('.tomb-info').on('click', function () {
		$(this).toggleClass('active');
		$(this).next().toggle();
	}); */

	$(
		'#gform_wrapper_15 .gfield:not(.gform_validation_container):not(#field_submit):not(#field_15_6):not(#field_15_10)'
	).each(function (index, value) {
		hoverLabelFix($(value), $(value).find('input'));
	});

	jQuery('.tooltip-container').on('click', 'svg', function () {
		jQuery(this).parent().find('.tooltip').toggleClass('active');

		if (jQuery(this).parent().find('.tooltip').hasClass('active')) {
			jQuery(this)
				.html(`<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
				<path stroke-linecap="round" stroke-linejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
			  </svg>`);
		} else {
			jQuery(this)
				.html(`<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
				<path stroke-linecap="round" stroke-linejoin="round" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
			</svg>`);
		}
	});

	jQuery(document).on('click', '#read-more', function () {
		$(this).toggleClass('active');

		if ($(this).hasClass('active')) {
			$(this).text('Visa mindre text');
		} else {
			$(this).text('Läs mer');
		}
		jQuery(this).closest('span.italic').next().toggle('fast');
	});
});

StickyHeader.init();

jQuery(window).on('scroll', function () {
	StickyHeader.init();
});

jQuery(window).on('load', function () {
	StickyHeader.init();
});

jQuery(window).on('resize', function () {
	StickyHeader.init();
});

function setDocHeight() {
	document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
}

window.addEventListener('resize', setDocHeight);
window.addEventListener('orientationchange', setDocHeight);
setDocHeight();

balanceText(jQuery('h1:not(.slider__heading)'), { watch: true }); // equivalent to $.balanceText('.my-class');
